import { render, staticRenderFns } from "./ProdutosCadastrados.vue?vue&type=template&id=236a9f7a&"
import script from "./ProdutosCadastrados.vue?vue&type=script&lang=js&"
export * from "./ProdutosCadastrados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports